import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import 'hammerjs';
import { CommonModule, DatePipe } from '@angular/common';

import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';

import { fuseConfig } from 'app/fuse-config';
import { MatDialogModule, MatInputModule, MatSelectModule } from '@angular/material';

import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';
import { SampleModule } from 'app/main/sample/sample.module';

import { AuthGuard } from './guard/auth.guard';
// import { AuthService } from './services/auth.service';
import { AppRoutingModule } from './app.routes';
import { FakeDbService } from 'app/fake-db/fake-db.service';
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';  // Addded
import { NgxSpinnerModule } from 'ngx-spinner';
import { CustomHttpInterceptorService } from './globalErrorHandler';
import { RedirectService } from './services/redirect.service';
// import { NgHttpLoaderModule } from 'ng-http-loader';
import { NgHttpLoaderModule } from 'ng-http-loader';
import {
    NgxUiLoaderModule, NgxUiLoaderHttpModule, NgxUiLoaderConfig,
    SPINNER,
    POSITION,
    PB_DIRECTION
} from 'ngx-ui-loader';
/*
const appRoutes: Routes = [
    {
        path      : '**',ballSpinClockwise #FED931
        redirectTo: 'sample' three-strings #2D323E
    }
];*/


const ngxUiLoaderConfig: NgxUiLoaderConfig = {
    bgsColor: '#2D323E',
    bgsPosition: POSITION.centerCenter,
    bgsSize: 80,
    bgsType: SPINNER.threeStrings, // background spinner type 
    fgsType: SPINNER.chasingDots, // foreground spinner type
    pbDirection: PB_DIRECTION.leftToRight, // progress bar direction
    pbThickness: 5 // progress bar thickness
};


@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        HttpClientModule,
        NgHttpLoaderModule.forRoot(),
        // RouterModule.forRoot(appRoutes),
        // RouterModule.forRoot(AppRoutingModule, { useHash: false }),   //From UNDP 

        TranslateModule.forRoot(),
        InMemoryWebApiModule.forRoot(FakeDbService, {
            delay: 0,
            passThruUnknownUrl: true
        }),

        // Material moment date module
        MatMomentDateModule,

        // Material
        MatButtonModule,
        MatIconModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,
        NgxSpinnerModule,
        NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
        NgxUiLoaderHttpModule,
        // NgxUiLoaderHttpModule.forRoot({
        //     exclude: [
        //       '/api/not/show/loader',
        //       '/api/logout',
        //       'https://external-domain.com/api/not/to/show'
        //     ]
        //   }),

        // App modules
        LayoutModule,
        SampleModule,

        // Routing
        AppRoutingModule,
        MatDialogModule,

    ],
    // providers: [AuthGuard/*, AuthService*/    ,  
    //     //  useClass: CustomHttpInterceptorService
    //     ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CustomHttpInterceptorService,
            multi: true
        },
        RedirectService,
        AuthGuard,
        DatePipe
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}
